var Backbone, SpinnerTemplate, SpinnerView;

Backbone = require('backbone');

SpinnerTemplate = require('../../spinner.html.mustache');

module.exports = SpinnerView = Backbone.View.extend({
  template: SpinnerTemplate,
  initialize: function(arg) {
    var ref;
    this.parentElem = arg.parentElem, this.css = arg.css, this.useV2 = arg.useV2;
    return (ref = this.parentElem) != null ? typeof ref.append === "function" ? ref.append(this.$el) : void 0 : void 0;
  },
  render: function() {
    this.stop();
    this.$el.html(this.template.render({
      useV2: this.useV2
    }));
    if (this.useV2) {
      if (this.css != null) {
        this.$el.find('.g-spinner').css(this.css);
      }
    } else {
      if (this.css != null) {
        this.$el.find('.t-spinner-small').css(this.css);
      }
    }
    return this;
  },
  isRunning: function() {
    return this.$el.is(':visible');
  },
  isInDom: function() {
    return $.contains(document.documentElement, this.$el[0]);
  },
  start: function() {
    var ref;
    if (!this.isInDom()) {
      if ((ref = this.parentElem) != null) {
        if (typeof ref.append === "function") {
          ref.append(this.$el);
        }
      }
    }
    return this.$el.show();
  },
  stop: function() {
    return this.$el.hide();
  }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL3NwaW5uZXIvZnJvbnRlbmQvdmlld3Mvc3Bpbm5lci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9hZGNhYmFsbGVyby9uYXBpc3RyYW5vL2J1aWxkLzE0OTI0Njc5NzUzNzktMzc5NTIvc3RhZ2luZy0yMDE3LjA0LjE3XzIyLjE1L2dvb2RzL21vZHVsZXMvc3Bpbm5lci9mcm9udGVuZC92aWV3cy9zcGlubmVyLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFDWCxlQUFBLEdBQWtCLE9BQUEsQ0FBUSw2QkFBUjs7QUFFbEIsTUFBTSxDQUFDLE9BQVAsR0FBaUIsV0FBQSxHQUFjLFFBQVEsQ0FBQyxJQUFJLENBQUMsTUFBZCxDQUM3QjtFQUFBLFFBQUEsRUFBVSxlQUFWO0VBRUEsVUFBQSxFQUFZLFNBQUMsR0FBRDtBQUNWLFFBQUE7SUFEWSxJQUFDLENBQUEsaUJBQUEsWUFBWSxJQUFDLENBQUEsVUFBQSxLQUFLLElBQUMsQ0FBQSxZQUFBO21GQUNyQixDQUFFLE9BQVEsSUFBQyxDQUFBO0VBRFosQ0FGWjtFQUtBLE1BQUEsRUFBUSxTQUFBO0lBQ04sSUFBQyxDQUFBLElBQUQsQ0FBQTtJQUNBLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLElBQUMsQ0FBQSxRQUFRLENBQUMsTUFBVixDQUFpQjtNQUFFLE9BQUQsSUFBQyxDQUFBLEtBQUY7S0FBakIsQ0FBVjtJQUNBLElBQUcsSUFBQyxDQUFBLEtBQUo7TUFDRSxJQUFxQyxnQkFBckM7UUFBQSxJQUFDLENBQUEsR0FBRyxDQUFDLElBQUwsQ0FBVSxZQUFWLENBQXVCLENBQUMsR0FBeEIsQ0FBNEIsSUFBQyxDQUFBLEdBQTdCLEVBQUE7T0FERjtLQUFBLE1BQUE7TUFHRSxJQUEyQyxnQkFBM0M7UUFBQSxJQUFDLENBQUEsR0FBRyxDQUFDLElBQUwsQ0FBVSxrQkFBVixDQUE2QixDQUFDLEdBQTlCLENBQWtDLElBQUMsQ0FBQSxHQUFuQyxFQUFBO09BSEY7O1dBSUE7RUFQTSxDQUxSO0VBY0EsU0FBQSxFQUFXLFNBQUE7V0FDVCxJQUFDLENBQUEsR0FBRyxDQUFDLEVBQUwsQ0FBUSxVQUFSO0VBRFMsQ0FkWDtFQWlCQSxPQUFBLEVBQVMsU0FBQTtXQUNQLENBQUMsQ0FBQyxRQUFGLENBQVcsUUFBUSxDQUFDLGVBQXBCLEVBQXFDLElBQUMsQ0FBQSxHQUFJLENBQUEsQ0FBQSxDQUExQztFQURPLENBakJUO0VBb0JBLEtBQUEsRUFBTyxTQUFBO0FBQ0wsUUFBQTtJQUFBLElBQTZCLENBQUksSUFBQyxDQUFBLE9BQUQsQ0FBQSxDQUFqQzs7O2FBQVcsQ0FBRSxPQUFRLElBQUMsQ0FBQTs7T0FBdEI7O1dBQ0EsSUFBQyxDQUFBLEdBQUcsQ0FBQyxJQUFMLENBQUE7RUFGSyxDQXBCUDtFQXdCQSxJQUFBLEVBQU0sU0FBQTtXQUNKLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFBO0VBREksQ0F4Qk47Q0FENkIifQ==
